export const CSRF_CUSTOM_HEADER = "x-requested-by";
